import React, { ReactElement } from 'react'
import { Helmet } from 'react-helmet'

export const DisableMobileZoom = (): ReactElement => (
  <Helmet>
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
  </Helmet>
)
